import { render, staticRenderFns } from "./uploadimg_small.vue?vue&type=template&id=1030e86c&scoped=true&"
import script from "./uploadimg_small.vue?vue&type=script&lang=js&"
export * from "./uploadimg_small.vue?vue&type=script&lang=js&"
import style0 from "./uploadimg_small.vue?vue&type=style&index=0&id=1030e86c&prod&lang=css&"
import style1 from "./uploadimg_small.vue?vue&type=style&index=1&id=1030e86c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1030e86c",
  null
  
)

export default component.exports